import React from 'react';
import PropTypes from 'prop-types';

import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

function PrivateLabelBrandBadge({ brand }) {
  return (
    <>
      {brand?.private_label_distributor_id && brand?.private_label_distributor ? (
        <>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                This is a private label brand of {brand?.private_label_distributor?.name}
              </Tooltip>
            }
          >
            <Badge variant="info" className={css(styles.privateLabelBadge)}>
              P
            </Badge>
          </OverlayTrigger>
        </>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  privateLabelBadge: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    cursor: 'help',
    marginLeft: '8px',
  },
});

PrivateLabelBrandBadge.propTypes = {
  brand: PropTypes.object.isRequired,
};

export default PrivateLabelBrandBadge;
